<template>
  <div style="padding-bottom: 6rem;">

    <header>
      <h1>SUPORTE</h1>
    </header>
    <section class="suporte">
      <div class="contaner">
        <div class="row">
          <div class="col-12 col-sm-12">
            <h1>FORMULÁRIO DE SUPORTE</h1>
            <hr class="divider">
          </div>
          <div class="col-8 col-sm-8 offset-2">
            <!-- <p>Por favor, forneça os detalhes da sua dúvida ou solicitação preenchendo o formulário abaixo que em breve iremos atendê-lo.</p> -->
          </div>
          <form id="formSuporte" @submit.prevent="onSubmit()">
            <!-- 1 -->
            <fieldset class="fieldset-border">
              <legend class="legend-border"><i class="fa-solid fa-code"></i>Informações da API</legend>
              <div class="row">
                <div class="col-4 col-sm-4 col-md-4">
                  <select class="form-select" ref="tipo" v-model="dados.tipo">
                    <option value="" selected>Tipo de solicitação</option>
                    <option value="Dúvida">Dúvida</option>
                    <option value="Erro">Erro</option>
                  </select>
                </div>
                <div class="col-4 col-sm-4 col-md-4">
                  <select class="form-select" ref="ambiente" v-model="dados.ambiente">
                    <option value="" selected>Selecione o Ambiente</option>
                    <option value="Aceitew">Aceite W</option>
                    <option value="Aceitey">Aceite Y</option>
                    <option value="Produção">Produção</option>
                  </select>
                </div>
                <div class="col-4 col-sm-4 col-md-4">
                  <select class="form-select" ref="selectCatalogo" v-model="selectCatalogo"
                    @change="atualizarSelectApi">
                    <option value="" selected>Selecione o Catálogo</option>
                    <option value="Vendas">Vendas</option>
                    <option value="Gestão">Gestão de Carteira</option>
                    <option value="Pós-venda">Pós Venda</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-4 col-sm-4 col-md-4">
                  <div class="form-outline">
                    <select class="form-select" ref="selectApi" v-model="selectApi" :disabled="!selectCatalogo">
                      <option value="" selected>Seleciona a API</option>
                      <option v-for="e in apis" :key="e" :value="formatarValue(e)">{{ e }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 col-sm-8 col-md-8" style="position: relative;">
                  <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="bottom" 
                   data-bs-html="true" title="Favor preencher com a URL ou o nome do serviço, essa informação pode ser localizada na documentação do Catálogo/API selecionada!">
                  </i>
                  <div class="form-outline url-servico">
                    <input type="text" class="form-control" id="" ref="urlServico" v-model="dados.urlServico">
                    <label class="form-label" for="">URL do serviço:</label>
                    <FormNotch />
                  </div>
                </div>
              </div>
            </fieldset>
            <!-- 2 -->
            <fieldset class="fieldset-border">
              <legend class="legend-border"><i class="fa-regular fa-message"></i>Mensagem</legend>
              <div class="row">
                <div class="col">
                  <div class="form-outline">
                    <textarea class="form-control" rows="5" placeholder="" ref="detalhe"
                      v-model="dados.detalhe"></textarea>
                    <label class="form-label" for="">Explique-nos um pouco mais sobre a sua dúvida ou
                      solicitação:</label>
                    <FormNotch />
                  </div>
                </div>
              </div>
            </fieldset>
            <!-- 3 -->
            <fieldset class="fieldset-border">
              <legend class="legend-border">
                <i class="fa-solid fa-paperclip"></i> Anexo
              </legend>
          
              <!-- input invisível -->
              <input
                type="file"
                ref="fileInput"
                @change="handleFileUpload"
                class="hidden-file-input"
              />
          
              <div class="row">
                <div class="col-8">
                  <button type="button" class="btn btn-primary" @click="triggerFileInput">
                    Selecionar arquivo
                  </button>
                </div>
                <div class="col-4 mb-4 col-filename">
                  <span class="file-name">{{ fileName || 'Nenhum arquivo selecionado' }}</span>
                </div>
              </div>
            </fieldset>

            <div class="row">
              <div class="col d-flex justify-content-center">
                <button type="submit" class="btn btn-primary mt-1">ENVIAR</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import FormNotch from './FormNotch.vue';
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';
import axios from "axios";

export default {
  components: {
    FormNotch
  },

  data() {
    return {
      selectCatalogo: "",
      selectApi: "",
      fileName: "",
      apis: [],
      dados: {
        tipo: "",
        ambiente: "",
        catalogo: "",
        api: "",
        urlServico: "",
        detalhe: ""
      },
      arquivo: null,
    };
  },

  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.fileName = file ? file.name : '';
      this.arquivo = event.target.files[0];
    },

    onSubmit() {
      switch (true) {

        case !this.dados.tipo:
          this.$refs.tipo.focus();
          alertUtils.alertError("Selecione o campo tipo de solicitação!");
          break;

        case !this.dados.ambiente:
          this.$refs.ambiente.focus();
          alertUtils.alertError("Selecione o ambiente!");
          break;

        case !this.selectCatalogo:
          this.$refs.selectCatalogo.focus();
          alertUtils.alertError("Selecione o catalogo!");
          break;

        case !this.selectApi:
          this.$refs.selectApi.focus();
          alertUtils.alertError("Selecione a API!");
          break;

        case !this.dados.urlServico:
          this.$refs.urlServico.focus();
          alertUtils.alertError("Informe a URL do serviço!");
          break;

        case !this.dados.detalhe:
          this.$refs.detalhe.focus();
          alertUtils.alertError("Informe os detalhes da sua solicitação!");
          break;

        default:
          this.dados.catalogo = this.selectCatalogo;
          this.dados.api = this.selectApi;
          this.salvar();
      }

    },

    async salvar() {
      loaderUtils.addLoarder();
      try {
        const response = await this.getIdSuporteApi();
        const idSuporteApi = response.data;
        console.log('ID Suporte:', response.data);

        if (this.arquivo) {
          await this.gravarAnexo(idSuporteApi);
        }

        const criarJira = await axios.get(`/massificados/corporativo/gerenciador-parceiros/suporte/rest/criar-jira/${idSuporteApi}`);
        console.log('criar jira:', criarJira.data);

        alertUtils.alertSuccess("Solicitação enviada com sucesso! Em breve você receberá um e-mail referente ao seu atendimento!")

      } catch (error) {
        alertUtils.alertError('Erro ao enviar a solicitação: ' + error.message);

      } finally {
        loaderUtils.removeLoader();
        this.resetForm();
      }
    },

    async getIdSuporteApi() {
      try {
        const response = await axios.post(`/massificados/corporativo/gerenciador-parceiros/suporte/salvar`, this.dados);
        return response;
      } catch (error) {
        throw error;
      }
    },

    async gravarAnexo(idSuporteApi) {
      const formData = new FormData();
      formData.append('file', this.arquivo); 

      try {
        const url = `/massificados/corporativo/gerenciador-parceiros/suporte/rest/gravar-anexo/${idSuporteApi}`;
        const response = await axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log('Upload de arquivo:', response.data);

      } catch (error) {
        throw error;
      }
    },

    atualizarSelectApi() {
      this.selectApi = "";
      switch (this.selectCatalogo) {
        case "Vendas":
          this.apis = ['Automóvel', 'Residencial', 'Imobiliário', 'Condomínio', 'Vida', 'Aluguel', 'Garantia', 'Empresarial', 'Equipamentos', 'Viagem', 'Cyber', 'E & O', 'E & O Saúde'];
          break;
        case "Gestão":
          this.apis = ['Apólice', 'Parcelas Pagas', 'Inadimplência', 'Comissão', 'Renovação', 'Pendência', 'Recusa', 'Sinistro'];
          break;
        case "Pós-venda":
          this.apis = ['Apólice', 'Endosso', 'Cartão segurado', 'Boleto'];
          break;
        default:
          this.apis = [];
      }
    },
    formatarValue(value) {
      let formattedValue = value;//.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //formattedValue = formattedValue.replace(/\s+/g, "");
      //formattedValue = formattedValue.toLowerCase();
      return formattedValue;
    },
    resetForm() {
      this.selectCatalogo = "";
      this.selectApi = "";
      this.apis = [];
      this.fileName = "";

      this.dados = {
        tipo: "",
        ambiente: "",
        catalogo: "",
        api: "",
        urlServico: "",
        detalhe: ""
      };

      this.arquivo = null;

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    }
  },

  created() {
    // console.log('criado');
  },

  mounted() {
     $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
  },
  
}
</script>

<style scoped>


.btn-fixo {
  position: absolute;
  right: 20px;
  z-index: 9999;
}

.hidden-file-input {
  display: none;
}
.col-filename {
  margin-left: -40%;
  margin-top: 5px;
}

.fa-info-circle{
  position: absolute;
    right: -7px;
    top: 10px;
    color: #0B9274;
}

.tooltip-inner {
  max-width: 250px;
  white-space: normal;
}
@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-api/css/style.css';
@import '/massificados/corporativo/gerenciador-parceiros-ui/suporte-portal-api/css/style.css';
</style>